import { IServiceInfo } from "@/domain/entities/serviceInfo/serviceInfo.types";
import { SERVICE_INFO } from "@/types";

export default function useGetServiceInfo(): IServiceInfo {
  const serviceInfo = window.sessionStorage.getItem(SERVICE_INFO) ?? "";
  return serviceInfo ? JSON.parse(serviceInfo) : ({} as IServiceInfo);
}
